import {FilterableColumn, ColumnType} from 'src/tracker/model/column/tracker-column'
import { powerStonesRemainingProperty } from 'src/tracker/model/property/calculated/power-stones-remaining-property'

export const powerstonesRemainingColumn = new FilterableColumn(
  "125px",
  ColumnType.TEXT,
  powerStonesRemainingProperty
)
